import React, { useState } from 'react'
import { Edit2, Trash2, ChevronDown, Package } from 'lucide-react'
import { formatCurrency } from '../../utils/formatters'
import { calculateRemainingStock } from '../../utils/calculations'
import './ProductCard.scss'

const ProductCard = ({
  product,
  purchases,
  onEdit,
  onDelete,
  onImageClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const remainingStock = calculateRemainingStock(product, purchases)

  return (
    <div className='product-card-compact'>
      <div className='card-header' onClick={() => setIsExpanded(!isExpanded)}>
        <div className='product-image-thumb'>
          {product.images && product.images.length > 0 ? (
            <div className='image-wrapper'>
              <img
                src={product.images[0]}
                alt={product.name}
                onClick={(e) => {
                  e.stopPropagation()
                  onImageClick(product.images)
                }}
              />
              {product.images.length > 1 && (
                <div className='image-count'>+{product.images.length - 1}</div>
              )}
            </div>
          ) : (
            <div className='no-image-placeholder'>
              <Package size={20} />
            </div>
          )}
        </div>

        <div className='product-summary'>
          <div className='product-name'>
            {product.name.length > 25
              ? product.name.substring(0, 25) + '...'
              : product.name}
          </div>
          <div className='product-quick-info'>
            <span className='product-code'>{product.code}</span>
            <span className='product-price'>
              {formatCurrency(product.basePrice)}
            </span>
          </div>
        </div>

        <div className='card-status'>
          <span
            className={`stock-badge ${
              remainingStock < 0
                ? 'critical'
                : remainingStock < 2
                  ? 'warning'
                  : 'success'
            }`}
          >
            Stock: {remainingStock}
          </span>
          <ChevronDown
            size={20}
            className={`expand-icon ${isExpanded ? 'expanded' : ''}`}
          />
        </div>
      </div>

      {isExpanded && (
        <div className='card-details'>
          <div className='details-section'>
            {(product.size || product.color) && (
              <div className='detail-row'>
                <span className='detail-label'>Caractéristiques</span>
                <div className='detail-value'>
                  <div className='specs-badges'>
                    {product.size && (
                      <span className='spec-badge'>Taille: {product.size}</span>
                    )}
                    {product.color && (
                      <span className='spec-badge'>
                        Couleur: {product.color}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className='detail-row'>
              <span className='detail-label'>Prix</span>
              <span className='detail-value highlight'>
                {formatCurrency(product.basePrice)}
              </span>
            </div>

            <div className='detail-row'>
              <span className='detail-label'>Stock disponible</span>
              <div className='detail-value'>
                <span
                  className={`stock-value ${
                    remainingStock < 0
                      ? 'critical'
                      : remainingStock < 2
                        ? 'warning'
                        : 'success'
                  }`}
                >
                  {remainingStock}
                  {remainingStock < 2 &&
                    remainingStock >= 0 &&
                    ' (Stock faible)'}
                  {remainingStock < 0 && ' (Rupture de stock)'}
                </span>
              </div>
            </div>

            <div className='detail-row'>
              <span className='detail-label'>Code produit</span>
              <span className='detail-value'>{product.code}</span>
            </div>
          </div>

          <div className='card-actions'>
            <button
              onClick={(e) => {
                e.stopPropagation()
                onEdit(product)
              }}
              className='btn secondary sm'
            >
              <Edit2 size={16} className='btn-icon' />
              Modifier
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation()
                onDelete(product)
              }}
              className='btn danger sm'
            >
              <Trash2 size={16} className='btn-icon' />
              Supprimer
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductCard
